<app-page-wrapper>
  <div class="header my-4">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-end">
        <h1 class="m-0 mr-2">
          License Tracking
        </h1>
      </div>
    </div>
  </div>

  <div class="mt-4" *ngIf="isInternal()">
    <app-org-license-details 
      [organizationId]="organizationId"
      >
    </app-org-license-details>
  </div>

  <div class="mt-4" *ngIf="!isInternal()">
    <div class="alert alert-warning">
      You do not have permission to view license information.
    </div>
  </div>
</app-page-wrapper> 